import { graphql } from '@data-access/graphql'

export const SendContactFormDocument = graphql(`
  mutation sendContactForm($input: ContactFormInput!) {
    sendContactForm(input: $input)
  }
`)
